module.exports = __webpack_public_path__ + "img/ic-header-menu-promotion.9620dc0a.png";